const cadastro_de_transporte_escolar_por_aluno = [
  {
    path: "/cadastro-de-transporte-escolar-por-aluno",
    redirect: "/cadastro-de-transporte-escolar-por-aluno",
    meta: {
      breadCrumb: "Gestão - Informação Complementar do Aluno",
    },
    children: [
      {
        path: "/cadastro-de-transporte-escolar-por-aluno",
        name: "cadastro_de_transporte_escolar_por_aluno",
        component: () =>
          import(
            "@/views/CadastroDeTransporteEscolarPorAluno/CadastroDeTransporteEscolarPorAluno.vue"
          ),
      },
      {
        path: "/cadastro-de-transporte-escolar-por-aluno-novo",
        name: "cadastro_de_transporte_escolar_por_aluno_novo",
        component: () =>
          import(
            "@/views/CadastroDeTransporteEscolarPorAluno/CadastroDeTransporteEscolarPorAlunoCad.vue"
          ),
      },
      {
        path: "/cadastro-de-transporte-escolar-por-aluno/editar/:id",
        name: "cadastro_de_transporte_escolar_por_aluno_editar",
        component: () =>
          import(
            "@/views/CadastroDeTransporteEscolarPorAluno/CadastroDeTransporteEscolarPorAlunoEdit.vue"
          ),
      },
    ],
  },
];

export { cadastro_de_transporte_escolar_por_aluno };
